import { SituacaoUpload, TipoDocumentoAlunoCertificacao } from 'src/tipos'

import { UploadDocumentos } from '../tipos'

export const RelacaoDocumentosAlunoCertificacao = new Array<UploadDocumentos>(
  {
    id: 1,
    tipo: TipoDocumentoAlunoCertificacao.Rg,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 1,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 2,
    tipo: TipoDocumentoAlunoCertificacao.RgVerso,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 2,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 3,
    tipo: TipoDocumentoAlunoCertificacao.DiplomaGraduacao,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 3,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 4,
    tipo: TipoDocumentoAlunoCertificacao.DiplomaGraduacaoVerso,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 4,
    obrigatorio: true,
    editarAprovado: true
  } as UploadDocumentos
)
